<script setup lang="ts">
import { useRenderStore } from "@/builder/stores/renderStore";

const renderStore = useRenderStore();
</script>

<template>
    <div class="prompt-container" :class="!renderStore.builderMode ? 'rd-p-8 md:rd-p-16' : 'rd-p-5'">
        <div class="rd-overflow-y-auto rd-max-h-[34.375rem] rd-w-full">
            <slot name="controls"></slot>

            <slot name="children"></slot>

            <slot name="content"></slot>
        </div>
    </div>
</template>